import { render, staticRenderFns } from "./admZ030.vue?vue&type=template&id=f4d25372&scoped=true"
import script from "./admZ030.vue?vue&type=script&lang=js"
export * from "./admZ030.vue?vue&type=script&lang=js"
import style0 from "./admZ030.vue?vue&type=style&index=0&id=f4d25372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d25372",
  null
  
)

export default component.exports